import Footer from 'components/common/Footer';
import NavBar from 'components/common/NavBar';
// import UserAgreementTwo from '../assets/UserAgreementTwo.png';
import '../styles/UserAgreement.scss';
import React, { useEffect } from 'react';

import ATable from '../components/table/AssetTable';

export const PublicDisclosurePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <NavBar />
      <div className="main_containter">
        <div className="container">
          <div className="inner_div">
            <h1>
              Public <span style={{ color: '#fff' }}> Disclosure </span>
            </h1>
          </div>
        </div>
        <div className="container_first">
          <p className="first_para">Last revised: 2-September-2025</p>

          <p className="second_para">
            Encryptus DMCC ("Encryptus") is currently in the process of
            obtaining license as Broker Dealer in relation to Virtual Assets by
            the Dubai Virtual Assets Regulatory Authority ("VARA"). These Public
            Disclosures are reviewed annually, unless there is a change in
            applicable regulations or Encryptus' business that requires
            implementation of an earlier update.
          </p>
        </div>
        {/* <img src={UserAgreementTwo} alt="FooterImage" /> */}
        <div className="container_second">
          <ol className="list-decimal ordered_list">
            <li>
              <h2>
                <strong>SERVICES</strong>
              </h2>
              <p>
                Encryptus operates as a broker-dealer in relation to virtual
                assets and facilitates over-the-counter trading in virtual
                assets where professional, retail and institutional investors
                are able to exchange fiat-virtual asset and vice versa. <br />
                The list of virtual assets and products offered by Encryptus is
                constantly evolving and our website will be updated as we add
                Virtual Assets to our offering. Currently Encryptus trades in
                the following virtual assets:
              </p>
              <br />
              <ATable />
              <p className="mt-[30px] md:!mt-[10px]">
                Encryptus will provide in a prominent manner on its platform,
                information pertaining to virtual assets it trades in. This
                includes:
              </p>
              <p>
                {' '}
                a. Name and symbol; <br />
                b. Date of issuance; <br />
                c. Market capitalization and fully diluted value; <br />
                d. Circulating supply including as a percentage of maximum total
                supply (if applicable); <br />
                e. Whether the virtual asset has been subject to an independent
                smart contract audit and the date of the most recent audit;{' '}
                <br />
                f. Largest reduction in price from high to low stated as both an
                absolute amount and a percentage change, including when it
                occurred; and <br />
                g. Information that can be found via publicly available data
                sources such as CoinMarketCap.
              </p>{' '}
            </li>

            <li>
              <h2>
                <strong>PRICING:</strong>
              </h2>
              <p>
                Prices are determined by Encryptus, taking into account, the
                following:
              </p>
              <p>a. External price sources from liquidity providers;</p>
              <p>b. The current risk position of Encryptus; and</p>
              <p>
                c. Per-client configurations, defined by Encryptus or, in some
                cases, at the request of the client.
              </p>
            </li>

            <li>
              <h2>
                <strong>EXECUTION</strong>
              </h2>
              <p>
                Client orders will always be executed by Encryptus on execution
                venues which Encryptus chooses. Encryptus will deal with the
                client as a principal, and act as the counterparty to each
                trade. A copy of Encryptus' order execution policy can be
                requested by emailing{' '}
                <a
                  href="mailto:hello@encryptus.io"
                  className="underline underline-offset-[8px]"
                >
                  hello@encryptus.io
                </a>
                .
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                In the event Encryptus routes 20% (twenty per cent) or more of
                its orders to any one liquidity source, the identity of such
                sources will be provided here:
              </p>
              <p className="mt-3">Falcon X Limited.</p>
              <p className="mt-[30px] md:!mt-[10px]">
                Encryptus does not introduce its clients to any other entities.
                Encryptus does not refer or introduce clients to other entities,
                including but not limit to, other VASPs.
              </p>
            </li>

            <li>
              <h2>
                <strong>HOLDING AND CONTROLLING CLIENT MONEY</strong>
              </h2>
              <p>
                In the process of providing its services, Encryptus will hold or
                control Client Money. The Client Money will be held in a
                separate, dedicated Client Money Account, purely for such
                purpose <strong>(Client Account)</strong>, with a designated
                Licensed Financial Institution, that are well versed with
                handling of Client Money. <br />
                Encryptus has put in place internal systems to ensure that
                Client Money is identifiable and secure at all times and that
                its own proprietary funds will not be commingled with the Client
                Money. Encryptus maintains systems and controls for identifying
                money which is not to be part of a Client Account and for
                transferring it without delay and Encryptus maintains adequate
                records of all payments of Client Money received by it.
              </p>
            </li>

            <li>
              <h2>
                <strong>HOLDING AND CONTROLLING CLIENT ASSETS</strong>
              </h2>
              <p>
                In the process of providing its services, Encryptus will hold
                and control Client Assets on an incidental basis. It is
                clarified that Encryptus will not act as a virtual assets
                custodian i.e., at no point will Encryptus provide only custody
                services to the Client. In the process of handling Client
                Assets, Encryptus uses third-party service providers, such as
                Fireblocks which provides wallet services to Encryptus that
                enable Encryptus to hold and monitor Client Assets.
              </p>
              <p>
                With respect to key arrangements, it is clarified that Encryptus
                may hold private keys to wallets in which Client Assets are
                held. Encryptus selects custody technology service providers
                only after having performed a solid due diligence. Custody
                arrangements entail an analysis on the regulatory status of the
                service provider, well-defined and structured internal approvals
                processes, as well as the adoption of strong risk management
                practices. Encryptus intends to appoint only entities ensuring
                asset segregation or equivalent safeguards for long-term custody
                purposes.
              </p>
            </li>

            <li>
              <h2>
                <strong>PRIVACY</strong>
              </h2>
              <p>
                Encryptus appreciates you trusting us with your personal data.
                We are committed to protecting your privacy. For more details,
                you can access our Privacy Policy &nbsp;{' '}
                <a
                  href="https://encryptus.io/legal/privacy"
                  className="underline underline-offset-[8px]"
                >
                  https://encryptus.io/legal/privacy
                </a>
                , and the Client Agreement &nbsp;{' '}
                <a
                  href="https://encryptus.io/useragreement"
                  className="underline underline-offset-[8px]"
                >
                  https://encryptus.io/useragreement
                </a>
                .
              </p>
            </li>

            <li>
              <h2>
                <strong>CLIENTS COMPLAINTS AND WHISTLEBLOWING</strong>
              </h2>
              <p>
                Encryptus is committed to promptly, fairly, consistently and
                efficiently resolving all complaints received by clients and/or
                other stakeholders. Encryptus views complaints from its clients
                as an opportunity to complete the loop, and continually improve
                the quality of its offerings. To that end, Encryptus has
                formulated and implemented comprehensive complaints handling
                procedures. If you seek to make any complaints, you can write to
                us at hello@encryptus.io.
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                Encryptus is committed to the highest standards of integrity,
                accountability, and transparency. Encryptus seeks to be
                responsive to all employees and stakeholders, be seen as a
                trusted organization that treats its employees with respect,
                demonstrate commitment to its own policies and applicable laws
                and regulations, and strengthen the "speak up" culture. An
                important aspect of this is a mechanism to enable voicing of
                concerns in a responsible and effective manner. If you are an
                employee of Encryptus or a stakeholder and seek to raise any
                concerns, you can write to us at hello@encryptus.io anonymously.
                You can also write to hello@encryptus.io for a copy of our
                whistleblower policy.
              </p>
            </li>

            <li>
              <h2>
                <strong>RISK</strong>
              </h2>
              <p>
                Virtual Assets transactions are subject to several risks,
                including but not limited to, market risks, credit risks,
                liquidity risks, and technology risks. Please read our detailed
                Risk Disclosure Statement{' '}
                <a
                  href="https://encryptus.io/riskdisclosure"
                  className="underline underline-offset-7"
                >
                  https://encryptus.io/riskdisclosure
                </a>
                for more information in this respect.
              </p>
            </li>

            <li>
              <h2>
                <strong>CONFLICT OF INTEREST</strong>
              </h2>
              <p>
                Encryptus is committed to conducting its business according to
                the principle that it must manage conflicts of interest
                appropriately. At present there are no actual, identified
                conflicts of interest arising out of Encryptus's Broker Dealer
                Services. Encryptus has, and will continue to identify potential
                conflicts of interest arising out of its outsourcing
                arrangements with group entities. Encryptus has put in place
                internal mechanisms and guardrails to ensure that no actual
                conflicts arise.
              </p>
            </li>

            <li>
              <h2>
                <strong>ANTI BRIBERY AND CORRUPTION</strong>
              </h2>
              <p>
                It is the policy of Encryptus to conduct all its business in an
                honest and ethical manner. Company has a zero-tolerance approach
                to Bribery and Corruption and are committed to acting
                professionally, fairly and with integrity in all our business
                dealings and relationships, and for implementing and enforcing
                effective systems to counter Bribery.
              </p>
            </li>

            <br />
            <li>
              <h2>
                <strong>ANTI MONEY LAUNDERING AND TERRORISM</strong>
              </h2>
              <p>
                At Encryptus DMCC, we are committed to maintaining the highest
                standards of regulatory compliance, financial integrity, and
                user protection. Our Anti-Money Laundering (AML) and Countering
                the Financing of Terrorism (CFT) program is meticulously
                designed to prevent the misuse of our platform for illicit
                activities, including money laundering and terrorist financing,
                in alignment with the stringent standards set by the Virtual
                Asset Regulatory Authority (VARA).
              </p>
            </li>

            <li>
              <h2>
                <strong>LEGAL AND REGULATORY ALIGNMENT</strong>
              </h2>
              <p>
                Encryptus DMCC operates under a regulatory framework supervised
                by the Dubai Virtual Asset Regulatory Authority (VARA). This
                includes adherence to the VARA Rulebooks, the UAE's Anti-Money
                Laundering and Countering the Financing of Terrorism laws, and
                other relevant federal and local regulations. We work closely
                with VARA and other regulators to ensure full compliance,
                transparency, and the protection of our clients' interests.
              </p>
            </li>

            <li>
              <h2>
                <strong>VIRTUAL ASSET STANDARDS</strong>
              </h2>
              <p>
                Encryptus takes reasonable steps, including but not limited to,
                conducting relevant due diligence to ensure that all Virtual
                Assets (as set out in greater detail in Annexure I (VA
                Standards) hereinbelow, that are supported by it to meet the
                standards set forth hereinunder, prior to, and at all times,
                during which it provides the Services and/or is engaged in any
                other virtual asset activities in relation to such Virtual
                Assets.
              </p>
              <p>
                Encryptus will consider, amongst others, the following criteria
                in relation to all supported Virtual Assets:
              </p>
              <p>
                a) Its market capitalisation, fully diluted value and liquidity,
                and whether such metrics have trended downwards over time;
              </p>
              <p>
                b) Its design, features and use cases, whether or not intended
                by the Issuer (as defined under the VARA Regulations) or
                relevant developers;
              </p>
              <p>
                c) Whether there are features which may materially affect
                Encryptus' compliance with applicable laws including the VARA
                Regulations, AML/CFT, sanctions, securities, and intellectual
                property;
              </p>
              <p>
                d) Regulatory treatment by VARA and other appropriate
                authorities (including authorities outside of the Emirate of
                Dubai), in particular whether the issuance of a relevant Virtual
                Asset has received any regulatory approvals;
              </p>
              <p>
                e) Whether a Virtual Asset is prohibited by VARA or any other
                appropriate authorities (both inside, or outside the UAE) in
                jurisdictions where Encryptus will provide 'broker-dealer'
                services, or equivalent activities, in relation to such Virtual
                Asset;
              </p>
              <p>
                f) The security and immutability of the underlying DLT protocol;
              </p>
              <p>
                g) Its future development (e.g. "roadmap") as communicated by
                the Issuer and/or relevant developers;
              </p>
              <p>
                h) Whether it may be susceptible to price manipulation for any
                reason and relevant mitigations that will be implemented by
                Encryptus;
              </p>
              <p>
                i) Whether potential or actual conflicts of interest that may
                arise, should Encryptus provide any Services in relation to the
                virtual asset and relevant mitigations;
              </p>
              <p>
                j) The background of its Issuer (as defined under the VARA
                Regulations) including, but not limited to, relevant experience
                in the virtual asset sector and whether it has been subject to
                any investigations or claims in relation to fraud or deceit;
              </p>
              <p>
                k) If a Virtual Asset represents rights to any other assets, the
                enforceability of such rights;
              </p>
              <p>
                l) Sufficient assets are available to satisfy any obligation
                with respect to any of the Services;
              </p>
              <p>
                Encryptus will ensure that the terms and conditions in relation
                to a Virtual Asset, reflect, to the extent possible, the
                operation of any existing underlying physical market and avoid
                adverse impacts to such market.
              </p>
              <p>
                Encryptus will review all terms and conditions in relation to a
                supported Virtual Asset on a periodic basis for appropriate
                correlation with any physical market, to ensure that such terms
                and conditions conform to standards and practices in that
                physical market.
              </p>
              <p>
                Encryptus will regularly, and at a minimum, annually, assess
                that a Virtual Asset, continues to meet and comply with these
                Listing Standards. In this respect, Encryptus will ensure that
                (a) in the event of any major global market development, (b)
                other external factors which impact the ability of a Virtual
                Asset to comply with these Listing Standards, or (c) upon the
                publication of a notice by VARA in relation to a Virtual Asset's
                ability to comply with these Listing Standards; immediately
                review the relevant Virtual Asset and reconfirm its suitability
                for being offered as part of its Services.
              </p>
              <p>
                Encryptus reserves the right to set conditions in relation to a
                Virtual Asset that may be suspended, including where a Virtual
                Asset no longer meets these Listing Standards. Encryptus shall
                have and implement all necessary operational procedures and
                controls in the event such conditions are met.
              </p>
              <p>
                Encryptus will notify VARA as soon as possible, after becoming
                aware that a Virtual Asset no longer meets these Listing
                Standards, and it will take such steps as VARA may direct, in
                order to minimise any adverse impact on any of Encryptus'
                clients as a result.
              </p>
              <p>
                Encryptus shall diligently and on a best-effort basis, maintain
                their books and records in their original form or native format,
                including those recorded on distributed ledgers, where
                appropriate. All records shall be retained for a minimum of
                eight (8) years and shall be available to inspection by VARA
                upon request.
              </p>
              <p>
                Encryptus will ensure that these Listing Standards are made
                available on its website. In the event these Listing Standards
                are amended and/or updated, such amendments and/or updates will
                reflect on the website accordingly, immediately thereafter.
              </p>
              <p>
                <strong>a. Ethereum:</strong>
              </p>
              <p>
                <strong>
                  Market Capitalization: Market Capitalization (as of September
                  2nd, 2025): The live Ethereum price is approximately
                  $4,383.88.
                </strong>
                The number of coins currently in circulation is Approximately
                120.7M Million, thus making its market cap roughly around
                $529.12B
              </p>
              <p>
                Source & date:{' '}
                <a
                  href="https://coinmarketcap.com/currencies/ethereum/"
                  className="underline underline-offset-7"
                >
                  https://coinmarketcap.com/currencies/ethereum/
                </a>
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                <strong>Fully Diluted Value (FDV):</strong> Ethereum project has
                not disclosed its maximum supply of coins and is considered to
                have infinite supply. The fully diluted value with the current
                coins in circulation is $529.12B
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                Source & date:{' '}
                <a
                  href="https://coinmarketcap.com/currencies/ethereum/"
                  className="underline underline-offset-7"
                >
                  https://coinmarketcap.com/currencies/ethereum/
                </a>
                , September 2nd 2025
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                <strong>Trend over time:</strong> Ethereum was first described
                in 2013 by Vitalik Buterin. Buterin, along with other
                co-founders, secured funding for the project in an online public
                crowd sale in the summer of 2014. The project team managed to
                raise $18.3 million in Bitcoin, and Ethereum's price in the
                Initial Coin Offering (ICO) was $0.311, with over 60 million
                Ether sold. Taking Ethereum's price now, this puts the return on
                investment (ROI) at an annualized rate of over 270%, essentially
                almost quadrupling your investment every year since the summer
                of 2014. Thus ETH has been on an uptrend since its launch.
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                Source & date:{' '}
                <a
                  href="https://coinmarketcap.com/currencies/ethereum/"
                  className="underline underline-offset-7"
                >
                  https://coinmarketcap.com/currencies/ethereum/
                </a>
                , September 2nd 2025
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                <strong>Design, features & use cases:</strong> Ethereum is a
                decentralized open-source blockchain system that features its
                own cryptocurrency, Ether. ETH works as a platform for numerous
                other cryptocurrencies, as well as for the execution of
                decentralized smart contracts.
                <p className="mt-[30px] md:!mt-[10px]">
                  Ethereum's own purported goal is to become a global platform
                  for decentralized applications, allowing users from all over
                  the world to write and run software that is resistant to
                  censorship, downtime and fraud.
                </p>{' '}
                <p className="mt-[30px] md:!mt-[10px]">
                  Ethereum has pioneered the concept of a blockchain smart
                  contract platform. Smart contracts are computer programs that
                  automatically execute the actions necessary to fulfill an
                  agreement between several parties on the internet. They were
                  designed to reduce the need for trusted intermediates between
                  contractors, thus reducing transaction costs while also
                  increasing transaction reliability.{' '}
                </p>{' '}
                <p className="mt-[30px] md:!mt-[10px]"></p>Ethereum's principal
                innovation was designing a platform that allowed it to execute
                smart contracts using the blockchain, which further reinforces
                the already existing benefits of smart contract technology.
                Ethereum's blockchain was designed, according to co-founder
                Gavin Wood, as a sort of "one computer for the entire planet,"
                theoretically able to make any program more robust,
                censorship-resistant and less prone to fraud by running it on a
                globally distributed network of public nodes.{' '}
              </p>{' '}
              <p className="mt-[30px] md:!mt-[10px]">
                In addition to smart contracts, Ethereum's blockchain is able to
                host other cryptocurrencies, called "tokens," through the use of
                its ERC-20 compatibility standard. In fact, this has been the
                most common use for the ETH platform so far: to date, more than
                280,000 ERC-20-compliant tokens have been launched. Over 40 of
                these make the top-100 cryptocurrencies by market
                capitalization, for example, USDT, LINK and BNB.
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                Source & date:{' '}
                <a
                  href="https://coinmarketcap.com/currencies/ethereum/"
                  className="underline underline-offset-7"
                >
                  https://coinmarketcap.com/currencies/ethereum/
                </a>
                , September 2nd 2025
              </p>
              <p className="">
                Source & date:{' '}
                <a
                  href="https://ethereum.org/en/what-is-ethereum/"
                  className="underline underline-offset-7"
                >
                  https://ethereum.org/en/what-is-ethereum/
                </a>
                , September 2nd 2025
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                <strong>Any features affecting VARA rule compliance:</strong> As
                of September 2nd 2025, there are no known features which may
                materially affect a VASP's compliance with applicable laws,
                Regulations, Rules or Directives.
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                <strong>
                  Regulatory treatment by VARA and other appropriate
                  authorities:
                </strong>{' '}
                As of September 2nd 2025, Ethereum is a common coin that is
                being accepted by VASP's regulated by VARA and other appropriate
                authorities around the world.
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                <strong>
                  Whether VA is prohibited by VARA or any other appropriate
                  authorities:
                </strong>{' '}
                September 2nd 2025 Ethereum is a common coin that is being
                accepted by VASP's regulated by VARA and also authorities around
                the world.
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                <strong>Security & immutability of DLT:</strong> Ethereum is
                very secure with decentralized smart-contract platform in
                existence. The roadmap aims to make the blockchain more secure
                by making subtle changes to the way Ethereum clients deal with
                competing blocks, as well as increasing the speed the network
                considers blocks to be "finalized". There are also improvements
                that make censoring transactions much more difficult by making
                block proposers blind to the actual contents of their blocks,
                and new ways to identify when a client is censoring.
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                Source & date:{' '}
                <a
                  href="https://ethereum.org/en/roadmap/security/"
                  className="underline underline-offset-7"
                >
                  https://ethereum.org/en/roadmap/security/
                </a>
                , September 2nd 2025
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                <strong>Future roadmap:</strong> The Ethereum roadmap outlines
                the specific improvements that will be made to protocol in the
                future. Overall, the roadmap will bring the following benefits
                to Ethereum users:
              </p>
              <ul className="!list-disc    gap-2">
                <li className=" gap-3 mt-3 list-item !list-disc">
                  {' '}
                  <p className="font-normal">
                    {' '}
                    Extra security:&nbsp; Source & date:&nbsp;
                    <a
                      href="https://ethereum.org/en/roadmap/security/"
                      className="underline underline-offset-7"
                    >
                      https://ethereum.org/en/roadmap/security/
                    </a>
                    , September 2nd 2025
                  </p>{' '}
                </li>
                <li className=" gap-3 mt-3 list-item !list-disc">
                  <p className="font-normal">
                    {' '}
                    Cheaper transactions:&nbsp; Source & date:&nbsp;
                    <a
                      href="https://ethereum.org/en/roadmap/scaling/"
                      className="underline underline-offset-7"
                    >
                      https://ethereum.org/en/roadmap/scaling/
                    </a>
                    , September 2nd 2025
                  </p>{' '}
                </li>
                <li className=" gap-3 mt-3 list-item !list-disc">
                  {' '}
                  <p className="font-normal">
                    {' '}
                    Better user experience:&nbsp; Source & date:&nbsp;
                    <a
                      href="https://ethereum.org/en/roadmap/user-experience/"
                      className="underline underline-offset-7"
                    >
                      https://ethereum.org/en/roadmap/user-experience/
                    </a>
                    , September 2nd 2025
                  </p>{' '}
                </li>
                <li className=" gap-3 mt-3 list-item !list-disc">
                  {' '}
                  <p className="font-normal">
                    {' '}
                    Future proofing:&nbsp; Source & date:&nbsp;
                    <a
                      href="https://ethereum.org/en/roadmap/future-proofing/"
                      className="underline underline-offset-7"
                    >
                      https://ethereum.org/en/roadmap/future-proofing/
                    </a>
                    , September 2nd 2025
                  </p>{' '}
                </li>
              </ul>
              <p className="mt-[30px] md:!mt-[10px]">
                <strong>
                  Whether VA is susceptible to price manipulation & steps taken
                  to overcome by VASP:
                </strong>{' '}
                <p className="mt-[30px] md:!mt-[10px]">
                  Encryptus takes compliance very seriously. We are integrated
                  with Industry leaders for Coin Monitoring, KYC Checks and
                  wallet custody solutions. Everything on our platform is
                  compliant and monitored to keep the ecosystem clean.
                </p>
                <p className="mt-[30px] md:!mt-[10px]">
                  To overcome or diminish the effect of price manipulation of a
                  VA, Encryptus performs the following:
                </p>
                <ul className="!list-disc  gap-2">
                  <li className="gap-3 mt-3 list-item !list-disc">
                    <p className="font-normal">
                      Transparent approach: We provide a quote of the price
                      expected and all other information before our client
                      begins trade with us.
                    </p>
                  </li>
                  <li className="gap-3 mt-3 list-item !list-disc">
                    <p className="font-normal">
                      We use leading third party software for KYC/KYB checks. We
                      also use websites like{' '}
                      <a
                        href="https://etherscan.io/"
                        className="underline underline-offset-7"
                      >
                        etherscan.io/
                      </a>{' '}
                      to check the legitimacy of each transaction.
                    </p>
                  </li>
                  <li className="gap-3 mt-3 list-item !list-disc">
                    <p className="font-normal">
                      We educate our clients on how to identify suspicious
                      trading activity to make the market more manipulation
                      resistive.
                    </p>
                  </li>
                  <li className="gap-3 mt-3 list-item !list-disc">
                    <p className="font-normal">
                      Take appropriate actions against account/wallet holders of
                      which seem to have performed a fraudulent transaction.
                    </p>
                  </li>
                </ul>
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                <strong>Background of issuer:</strong> Although the Ethereum
                blockchain has a number of founders, Vitalik Buterin was the one
                who initially published a white paper explaining the concept of
                Ethereum in November 2013. Following Buterin's initial work,
                other brains jumped on board in various capacities to help bring
                the project to fruition. Vitalik Buterin, Gavin Wood, Charles
                Hoskinson, Amir Chetrit, Anthony Di Iorio, Jeffrey Wilcke,
                Joseph Lubin and Mihai Alisie are all considered co-founders of
                Ethereum.
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                <strong>b. Bitcoin</strong>
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                <strong>Market Capitalization:</strong> The live Bitcoin price
                today (As of September 2nd 2025) is 110,123.58 USD. The number
                of coins currently in circulation is 19.9M BTC, thus making its
                market cap roughly around $2.31T
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                Source & date:{' '}
                <a
                  href="https://coinmarketcap.com/currencies/bitcoin/"
                  className="underline underline-offset-7"
                >
                  https://coinmarketcap.com/currencies/bitcoin/
                </a>
                , September 2nd 2025
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                <strong>Fully Diluted Value (FDV):</strong> Bitcoin project has
                a maximum supply of 21M BTC coins. The fully diluted value will
                be $2.31T
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                Source & date:{' '}
                <a
                  href="https://coinmarketcap.com/currencies/bitcoin/"
                  className="underline underline-offset-7"
                >
                  https://coinmarketcap.com/currencies/bitcoin/
                </a>
                , 02/09/2025
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                <strong>Trend over time:</strong> The all-time low price of
                Bitcoin is $0.04865 USD, on Jul 14, 2010 and the all-time high
                is $68,789.63 USD, on Nov 10, 2021. The current price, as of
                01/08/2021 is $28,908.17 USD. Hence Bitcoin has been on an
                upward trend over time.
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                Source & date:{' '}
                <a
                  href="https://coinmarketcap.com/currencies/bitcoin/"
                  className="underline underline-offset-7"
                >
                  https://coinmarketcap.com/currencies/bitcoin/
                </a>
                , 02/09/2025
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                <strong>Design, features & use cases:</strong> Bitcoin is a
                decentralized cryptocurrency originally described in a 2008
                whitepaper by a person, or group of people, using the alias
                Satoshi Nakamoto. It was launched soon after, in January 2009.
                Bitcoin is a peer-to-peer online currency, meaning that all
                transactions happen directly between equal, independent network
                participants, without the need for any intermediary to permit or
                facilitate them. Bitcoin's most unique advantage comes from the
                fact that it was the very first cryptocurrency to appear on the
                market. It has managed to create a global community and give
                birth to an entirely new industry of millions of enthusiasts who
                create, invest in, trade and use Bitcoin and other
                cryptocurrencies in their everyday lives. The emergence of the
                first cryptocurrency has created a conceptual and technological
                basis that subsequently inspired the development of thousands of
                competing projects.
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                <strong>Any features affecting VARA rule compliance:</strong> As
                of September 2nd 2025, there are no known features which may
                materially affect a VASP's compliance with applicable laws,
                Regulations, Rules or Directives.
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                <strong>
                  Regulatory treatment by VARA and other appropriate
                  authorities:
                </strong>{' '}
                As of September 2nd 2025, Bitcoin is a common coin that is being
                accepted by VASP's regulated by VARA and other appropriate
                authorities around the world. Although the SEC has bought crypto
                exchanges under scrutiny for certain unregistered business
                activities, Bitcoin has not been named in any lawsuit.
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                Source & date
                <a
                  href="https://www.cnbc.com/2023/06/12/coinbase-sued-by-sec-over-alleged-unregistered-securities.html"
                  className="underline underline-offset-7"
                >
                  https://www.cnbc.com/2023/06/12/coinbase-sued-by-sec-over-alleged-unregistered-securities.html
                </a>
                , Published Mon, Jun 12 2023
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                <strong>
                  Whether VA is prohibited by VARA or any other appropriate
                  authorities:
                </strong>{' '}
                As of September 2nd 2025, Bitcoin is a common coin that is being
                accepted by VASP's regulated by VARA and also authorities around
                the world.
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                <strong>Security & immutability of DLT:</strong> The Bitcoin
                network and currency has proven to be secure, functional, and
                efficient. The technology used to build Bitcoin is
                mathematically secured by the laws of the universe, and is
                constantly being improved upon by the open-source community. The
                software is actively inspected, and audited by this growing
                community.
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                Source and date:
                <a
                  href="https://help.coinbase.com/en/coinbase/privacy-and-security/other/is-bitcoin-secure-has-the-bitcoin-network-ever-been-hacked"
                  className="underline underline-offset-7"
                >
                  https://help.coinbase.com/en/coinbase/privacy-and-security/other/is-bitcoin-secure-has-the-bitcoin-network-ever-been-hacked
                </a>
                , 02/08/2023
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                <strong>Future roadmap:</strong> Bitcoin has been consistently
                growing to achieve the project target of being an online
                currency for day-to-day transactions. The future roadmap of
                Bitcoin is to advance in their ecosystem to achieve this target.
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                Source and date:
                <a
                  href="https://www.investopedia.com/tech/what-will-happen-bitcoin-next-decade/"
                  className="underline underline-offset-7"
                >
                  https://www.investopedia.com/tech/what-will-happen-bitcoin-next-decade/
                </a>
                , 01/12/22 Updated October 13, 2024
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                <strong>
                  Whether VA is susceptible to price manipulation & steps taken
                  to overcome by VASP:
                </strong>{' '}
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                Encryptus takes compliance very seriously. We are integrated
                with Industry leaders for Coin Monitoring, KYC Checks and wallet
                custody solutions. Everything on our platform is compliant and
                monitored to keep the ecosystem clean.
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                To overcome or diminish the effect of price manipulation of a
                VA, Encryptus performs the following:
              </p>
              <ul className="!list-disc  gap-2">
                <li className="gap-3 mt-3 list-item !list-disc">
                  <p className="font-normal">
                    Transparent approach: We provide a quote of the price
                    expected and all other information before our client begins
                    trade with us.
                  </p>
                </li>
                <li className="gap-3 mt-3 list-item !list-disc">
                  <p className="font-normal">
                    We use leading third party software for KYC/KYB checks. We
                    also use website like
                    <a
                      href="https://www.blockchain.com/explorer"
                      className="underline underline-offset-7"
                    >
                      {' '}
                      https://www.blockchain.com/explorer
                    </a>{' '}
                    to check the legitimacy of each transaction.
                  </p>
                </li>
                <li className="gap-3 mt-3 list-item !list-disc">
                  <p className="font-normal">
                    We educate our clients on how to identify suspicious trading
                    activity to make the market more manipulation resistive.
                  </p>
                </li>
                <li className="gap-3 mt-3 list-item !list-disc">
                  <p className="font-normal">
                    Take appropriate actions against account/wallet holders of
                    which seem to have performed a fraudulent transaction.
                  </p>
                </li>
              </ul>
              <p className="mt-[30px] md:!mt-[10px]">
                <strong>Background of issuer:</strong> Bitcoin's original
                inventor is known under a pseudonym, Satoshi Nakamoto. As of
                2021, the true identity of the person — or organization — that
                is behind the alias remains unknown.
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                Source & date:{' '}
                <a
                  href="https://coinmarketcap.com/currencies/bitcoin/"
                  className="underline underline-offset-7"
                >
                  https://coinmarketcap.com/currencies/bitcoin/
                </a>
                , 02/09/2025
              </p>
              <p>
                <strong>c. USDT</strong>
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                <strong>&nbsp;Market Capitalization:</strong> The live USDT
                price today (As of 02/09/2025) is $1 USD. The number of coins
                currently in circulation is 168.02B USDT, thus making its market
                cap roughly around 168.05 USD.
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                Source & date:{' '}
                <a
                  href="https://coinmarketcap.com/currencies/tether/"
                  className="underline underline-offset-7"
                >
                  https://coinmarketcap.com/currencies/tether/
                </a>
                , 02/09/2025
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                <strong>Fully Diluted Value (FDV):</strong> There is no known
                maximum supply for Tether's USDT, as new coins are issued based
                on user demand and reserves held by Tether. The fully diluted
                value will be $172.76B
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                Source & date:{' '}
                <a
                  href="https://coinmarketcap.com/currencies/tether/"
                  className="underline underline-offset-7"
                >
                  https://coinmarketcap.com/currencies/tether/
                </a>
                , 02/09/2025
              </p>
              <p>
                <strong className="mt-[30px] md:!mt-[10px]">
                  Trend over time:
                </strong>{' '}
                Tether tokens are assets that move across the blockchain just as
                easily as other digital currencies but that are pegged to
                real-world currencies on a 1-to-1 basis.
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                Source & date:{' '}
                <a
                  href="https://tether.to/en/how-it-works"
                  className="underline underline-offset-7"
                >
                  https://tether.to/en/how-it-works
                </a>
                , 02/09/2025
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                <strong>Design, features & use cases:</strong> Tether tokens are
                assets that move across the blockchain just as easily as other
                digital currencies but that are pegged to real-world currencies
                on a 1-to-1 basis. Tether tokens are referred to as stablecoins
                because they offer price stability as they are pegged to a fiat
                currency. This offers traders, merchants and funds a low
                volatility solution when exiting positions in the market. All
                Tether tokens are pegged at 1-to-1 with a matching fiat currency
                (e.g., 1 USD₮ = 1 USD) and are backed 100% by Tether's reserves.
                As a fully transparent company, we publish a record of the
                current reserve assets.
              </p>
              <p>
                Source & date:{' '}
                <a
                  href="https://tether.to/en/how-it-works"
                  className="underline underline-offset-7"
                >
                  https://tether.to/en/how-it-works
                </a>
                , 02/09/2025
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                <strong>Any features affecting VARA rule compliance:</strong> As
                of September 2nd 2025, there are no known features which may
                materially affect a VASP's compliance with applicable laws,
                Regulations, Rules or Directives. It is also a fully transparent
                company, who publishes records of the current reserve assets.
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                <strong>
                  Regulatory treatment by VARA and other appropriate
                  authorities:
                </strong>{' '}
                As of September 2nd 2025, USDT is a common coin that is being
                accepted by VASP's regulated by VARA and other appropriate
                authorities around the world.
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                <strong>
                  Whether VA is prohibited by VARA or any other appropriate
                  authorities:
                </strong>{' '}
                As of September 2nd 2025, USDT is a common coin that is being
                accepted by VASP's regulated by VARA and also authorities around
                the world.
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                <strong>Security & immutability of DLT:</strong> USDT is a
                stable coin and hence provides stability with respect to price
                movements in the market. USDT's unique feature is the fact that
                its value is guaranteed by Tether to remain pegged to the U.S.
                dollar. According to Tether, whenever it issues new USDT tokens,
                it allocates the same amount of USD to its reserves, thus
                ensuring that USDT is fully backed by cash and cash equivalents.
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                Source & date:{' '}
                <a
                  href="https://coinmarketcap.com/currencies/tether/"
                  className="underline underline-offset-7"
                >
                  https://coinmarketcap.com/currencies/tether/
                </a>
                , 02/08/2023
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                <strong>Future roadmap:</strong> USDT aims to be driving the
                future of money by being the most widely adopted stablecoins,
                having pioneered the concept in the digital token space.
              </p>
              <p>
                Source & date:{' '}
                <a
                  href="https://tether.to/en/"
                  className="underline underline-offset-7"
                >
                  https://tether.to/en/
                </a>
                , 02/09/2025
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                <strong>
                  Whether VA is susceptible to price manipulation & steps taken
                  to overcome by VASP:
                </strong>{' '}
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                Encryptus takes compliance very seriously. We are integrated
                with Industry leaders for Coin Monitoring, KYC Checks and wallet
                custody solutions. Everything on our platform is compliant and
                monitored to keep the ecosystem clean.
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                To overcome or diminish the effect of price manipulation of a
                VA, Encryptus performs the following:
              </p>
              <ul className="!list-disc l gap-2">
                <li className="gap-3 mt-3 list-item !list-disc">
                  <p className="font-normal">
                    Transparent approach: We provide a quote of the price
                    expected and all other information before our client begins
                    trade with us.
                  </p>
                </li>
                <li className="gap-3 mt-3 list-item !list-disc">
                  <p className="font-normal">
                    We use leading third party software for KYC/KYB checks. We
                    also use website like{' '}
                    <a
                      href="https://etherscan.io/"
                      className="underline underline-offset-7"
                    >
                      etherscan.io/
                    </a>{' '}
                    to check the legitimacy of each transaction.
                  </p>
                </li>
                <li className="gap-3 mt-3 list-item !list-disc">
                  <p className="font-normal">
                    We educate our clients on how to identify suspicious trading
                    activity to make the market more manipulation resistive.
                  </p>
                </li>
                <li className="gap-3 mt-3 list-item !list-disc">
                  <p className="font-normal">
                    Take appropriate actions against account/wallet holders of
                    which seem to have performed a fraudulent transaction.
                  </p>
                </li>
              </ul>
              <p className="mt-[30px] md:!mt-[10px]">
                <strong>Background of issuer:</strong> USDT — or as it was known
                at the time, Realcoin — was launched in 2014 by Brock Pierce,
                Reeve Collins and Craig Sellars.
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                Source & date:{' '}
                <a
                  href="https://coinmarketcap.com/currencies/tether/"
                  className="underline underline-offset-7"
                >
                  https://coinmarketcap.com/currencies/tether/
                </a>
                , 02/09/2025
              </p>
              <p>
                <strong>d. USDC</strong>
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                <strong>Market Capitalization:</strong> The live USDC price
                today (As of 02/08/2023) is $0.999USD. The number of coins
                currently in circulation is 71.79B USDC, thus making its market
                cap roughly around $2.24B USD.
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                Source & date:{' '}
                <a
                  href="https://coinmarketcap.com/currencies/usd-coin/"
                  className="underline underline-offset-7"
                >
                  https://coinmarketcap.com/currencies/usd-coin/
                </a>
                , 02/09/2025
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                <strong>Fully Diluted Value (FDV):</strong> There is no known
                maximum supply for USDC. Each USDC is issued as an ERC-20 token
                on the Ethereum blockchain and is 100% collateralized by a
                corresponding USD held in accounts subject to regular public
                reporting of reserves. The fully diluted value with the current
                coins in circulation is 71.78B
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                Source & date:{' '}
                <a
                  href="https://coinmarketcap.com/currencies/usd-coin/"
                  className="underline underline-offset-7"
                >
                  https://coinmarketcap.com/currencies/usd-coin/
                </a>
                , 02/09/2025
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                <strong>Trend over time:</strong> USDC tokens are assets that
                move across the blockchain just as easily as other digital
                currencies but that are pegged to real-world currencies on a
                1-to-1 basis.
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                Source & date:{' '}
                <a
                  href="https://coinmarketcap.com/currencies/usd-coin/"
                  className="underline underline-offset-7"
                >
                  https://coinmarketcap.com/currencies/usd-coin/
                </a>
                , 02/09/2025
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                <strong>Design, features & use cases:</strong> USDC tokens are
                assets that move across the blockchain just as easily as other
                digital currencies but that are pegged to real-world currencies
                on a 1-to-1 basis.
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                Source & date:{' '}
                <a
                  href="https://coinmarketcap.com/currencies/usd-coin/"
                  className="underline underline-offset-7"
                >
                  https://coinmarketcap.com/currencies/usd-coin/
                </a>
                , 02/09/2025
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                <strong>Any features affecting VARA rule compliance:</strong> As
                of September 2nd 2025, there are no known features which may
                materially affect a VASP's compliance with applicable laws,
                Regulations, Rules or Directives. The reserve is subject to
                third party attestation that there are sufficient assets to meet
                liabilities
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                Source & date:{' '}
                <a
                  href="https://www.circle.com/en/usdc"
                  className="underline underline-offset-7"
                >
                  https://www.circle.com/en/usdc
                </a>
                , 02/09/2025
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                <strong>
                  Regulatory treatment by VARA and other appropriate
                  authorities:
                </strong>{' '}
                As of September 2nd 2025, USDC is a common coin that is being
                accepted by VASP's regulated by VARA and other appropriate
                authorities around the world.
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                <strong>
                  Whether VA is prohibited by VARA or any other appropriate
                  authorities:
                </strong>{' '}
                As of September 2nd 2025, USDC is a common coin that is being
                accepted by VASP's regulated by VARA and also authorities around
                the world.
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                <strong>Security & immutability of DLT:</strong> USDC is a
                stable coin and hence provides stability with respect to price
                movements in the market. USDC's unique feature is the fact that
                its value is guaranteed by Circle to remain pegged to the U.S.
                dollar. According to Circle, whenever it issues new USDC tokens,
                it allocates the same amount of USD to its reserves, thus
                ensuring that USDC is fully backed by cash and cash equivalents.
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                <strong>Future roadmap:</strong> USDC is a faster, safer, and
                more efficient way to send, spend, and exchange money around the
                globe. USDC powers apps to provide anytime access to payments
                and financial services.
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                Source & date:{' '}
                <a
                  href="https://www.circle.com/en/usdc"
                  className="underline underline-offset-7"
                >
                  https://www.circle.com/en/usdc
                </a>
                , 02/09/2025
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                <strong>
                  Whether VA is susceptible to price manipulation & steps taken
                  to overcome by VASP:
                </strong>{' '}
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                Encryptus takes compliance very seriously. We are integrated
                with Industry leaders for Coin Monitoring, KYC Checks and wallet
                custody solutions. Everything on our platform is compliant and
                monitored to keep the ecosystem clean.
              </p>
              <p className="mt-[30px] md:!mt-[10px]">
                To overcome or diminish the effect of price manipulation of a
                VA, Encryptus performs the following:
              </p>
              <ul className="!list-disc  gap-2">
                <li className="gap-3 mt-3 list-item !list-disc">
                  <p className="font-normal">
                    Transparent approach: We provide a quote of the price
                    expected and all other information before our client begins
                    trade with us.
                  </p>
                </li>
                <li className="gap-3 mt-3 list-item !list-disc">
                  <p className="font-normal">
                    We use leading third party software for KYC/KYB checks. We
                    also use website like{' '}
                    <a
                      href="https://etherscan.io/"
                      className="underline underline-offset-7"
                    >
                      etherscan.io/
                    </a>{' '}
                    to check the legitimacy of each transaction.
                  </p>
                </li>
                <li className="gap-3 mt-3 list-item !list-disc">
                  <p className="font-normal">
                    We educate our clients on how to identify suspicious trading
                    activity to make the market more manipulation resistive.
                  </p>
                </li>
                <li className="gap-3 mt-3 list-item !list-disc">
                  <p className="font-normal">
                    Take appropriate actions against account/wallet holders of
                    which seem to have performed a fraudulent transaction.
                  </p>
                </li>
              </ul>
              <p className="mt-[30px] md:!mt-[10px]">
                <strong>Background of issuer:</strong> Jeremy Allaire is CEO of
                Circle, one of the primary issuers of the dollar-pegged USD
                Coin, one of the fastest growing stablecoins in the world.
              </p>
              <p>
                Source & date:{' '}
                <a
                  href="https://www.circle.com/en/about-circle"
                  className="underline underline-offset-7"
                >
                  https://www.circle.com/en/about-circle
                </a>
                , 02/09/2025
              </p>
            </li>

            <li>
              <h2>
                <strong>PAST CONVICTIONS</strong>
              </h2>
              <p>
                Encryptus and any member[s] of its Senior Management or Board
                have not faced any past convictions or prosecutions of, whether
                before the courts of the UAE or the courts of another
                jurisdiction.
              </p>
            </li>
          </ol>
        </div>
      </div>
      <br />
      <Footer />
    </>
  );
};
